import { Pipe, PipeTransform } from '@angular/core';
import { NPIOverrideType } from '@rivethealth/data/npi';
import { Payer } from '@rivethealth/data/payer';

@Pipe({ name: 'npiOverride', pure: true })
export class NpiOverridePipe implements PipeTransform {
  constructor() {}

  transform(payer: Payer): string {
    const combinedOverride: NPIOverrideType =
      payer.npiOverride || payer.systemPayer.npiOverride || 'no_override';
    switch (combinedOverride) {
      case 'type_one':
        return 'Type 1';
      case 'type_two':
        return 'Type 2';
    }
    return '';
  }
}
